// extracted by mini-css-extract-plugin
export default {"main":"SparkChart--main--+RoJR"};